import "./singleCategoryMobile.scss";
import { Translate } from "react-localize-redux";
import BaseButton from "wallet-elementkit/dist/elementKit/baseButton/BaseButton";
import { ReactComponent as ArrowNext } from "../../../../assets/common/arrow-next.svg";

const SingleCategoryMobile = (props) => {
	return (
		<div
			id="issuer-profile-single-category-mobile"
			className=" flex-row jc-sb"
			style={props.styles}
		>
			<div className="flex-row" style={{ height: "100%" }}>
				<div className="category-info flex-column jc-sb ai-fs">
					<span className="category-title s4">{props.title}</span>
					<span className="credential-count">
						<Translate
							id={
								props.count > 1 ? "totalCredentialsPlural" : "totalCredentials"
							}
							data={{ credentialCount: props.count }}
						/>
					</span>
				</div>
			</div>
			{props.onClickAction && props.count ? (
				<BaseButton
					size="small"
					type="secondary"
					loading={false}
					width={47}
					height={26}
					onClickAction={props.onClickAction}
				>
					<ArrowNext
						className="customizable-icon"
						width={11}
						height={16}
						alt="arrow next"
					/>
				</BaseButton>
			) : null}
		</div>
	);
};

export default SingleCategoryMobile;
